// utils/fetchData.js
import structure from "./api.json";

const fallbackData = structure.data ?? structure;

export const getStoredData = () => {
  try {
    const storedData = localStorage.getItem("apiData");
    return storedData ? JSON.parse(storedData) : fallbackData;
  } catch (error) {
    console.error("Error reading stored data:", error);
    return fallbackData;
  }
};

export const fetchAndStoreData = async () => {
  try {
    const response = await fetch(
      "https://json-backend.vercel.app/json/6a03dddfd83cd9537791421e",
    );

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const result = await response.json();
    if (result.data == null) throw new Error("API returned no data");

    localStorage.setItem("apiData", JSON.stringify(result.data));
    window.dispatchEvent(new Event("apiDataUpdated"));
  } catch (error) {
    console.error("Error fetching data; using available fallback:", error);
  }
};

fetchAndStoreData();
